import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {
    discovery_rule_id?: String,
    discoveryRule? : String,
    filterSummary? : any
}

export const updateDiscoveryRuleDetail = ({
    discovery_rule_id,
    discoveryRule,
    filterSummary,
    eventEmitter,
}: Props) => {
    eventEmitter.emit(Event.updateDiscoveryRuleDetail, {discovery_rule_id, discoveryRule, filterSummary});
  
};

